import {
  Statuses,
  quarterReviewStatuses,
  statusArray,
  statusColors,
  statusesLabel,
} from '../../helper';

interface Props {
  status: `${Statuses}` | number | any;
  from?: 'quarter';
}

const Status = ({ status, from }: Props) => {
  if (from) {
    status =
      from === 'quarter' ? quarterReviewStatuses[Number(status)] : status;
  } else
    status = typeof status === 'number' ? statusArray[Number(status)] : status;

  return (
    <div className="flex gap-x-2 items-center">
      <div
        style={{ background: `${statusColors[status] || ''}` }}
        className="w-2 h-2 rounded-full"
      ></div>
      <div>{statusesLabel[status] || ''}</div>
    </div>
  );
};

export default Status;
